import gql from "graphql-tag"

export default gql`
  query allSlideTags($user: String!) {
    allSlideTags: slideTags(
      filter: {
        user: { username: { equalTo: $user } }
        name: { equalTo: "new" }
      }
    ) {
      slides(orderBy: POS_ASC) {
        id
        file: image {
          id
          secret
        }
        videoUrl
        width
        height
        title
        description
        slideKeyValues: keyValues {
          id
          slideKey: key {
            id
            name
          }
          value
        }
        album {
          id
          title
          slug
          tags {
            id
            name
          }
          keyValues {
            id
            value
            key {
              id
              name
            }
          }
        }
      }
    }
  }
`
